/**
 * PlaylistRow - プレイリスト1件分の行（一覧・追加シートで共用）
 */

import { ListMusic } from 'lucide-react'

import type { MusicPlaylistItem } from '@/api/type'
import { AuthImage } from '@/components/ui/auth-image'

type Props = {
  playlist: MusicPlaylistItem
  onClick: () => void
}

export const PlaylistRow = ({ playlist, onClick }: Props) => (
  <button type="button" onClick={onClick} className="flex w-full items-center gap-3 border-none text-left">
    <span className="block size-14 shrink-0 overflow-hidden rounded-md bg-white/10">
      {playlist.thumbnail ? (
        <AuthImage
          src={playlist.thumbnail}
          alt={playlist.name}
          className="size-full object-cover"
          cacheKey={`music-playlist-${playlist.id}`}
        />
      ) : (
        <span className="flex size-full items-center justify-center">
          <ListMusic size={20} className="text-muted-foreground" />
        </span>
      )}
    </span>
    <span className="flex min-w-0 flex-1 flex-col border-b border-white/10 py-3 pr-4">
      <span className="truncate">{playlist.name}</span>
      <span className="text-sm text-muted-foreground">{playlist.track_count}曲</span>
    </span>
  </button>
)
